import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeyValueTagEditorComponent } from './key-value-tag-editor.component';

@NgModule({
  declarations: [KeyValueTagEditorComponent],
  imports: [CommonModule],
  exports: [KeyValueTagEditorComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KeyValueTagEditorModule {}
